<template>
  <div class="modal fade" id="investi-print-pdf" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true">
    <div class="modal-dialog wider-1 wider-print9" role="document">
      <div class="modal-content">
        <div id="cover-spin" v-if="isrefreshinv"></div>
        <div class="modal-body p-0">
          <div class="pb-3 pr-5 pl-5 pt-3">
            <div class="row" style="margin:0 auto;">
              <div class="col-md-12 padr-0">
                <div v-if="showhideemailpopup">
                  <div class="modal fade" id="Sendemailin" tabindex="-1" role="dialog"
                    aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                    <div class="modal-dialog grt-md" role="document" style="
            width: 570px;
            background: #fff;
            border-radius: 3px;
            -webkit-border-radius: 3px;
          ">
                      <div class="modal-content" style="padding: 20px 50px">
                        <div class="modal-header">
                          <h5 style="margin: 0px auto">Send Email</h5>
                          <button type="button" class="close" data-dismiss="modal" aria-label="Close" style="top: 10px">
                            <span aria-hidden="true">&times;</span>
                          </button>
                        </div>
                        <div class="modal-body">
                          <ul class="list-select" style="margin-bottom: 0px">
                            <li class="data-hold" v-for="item in emaillist" :key="item">
                              <span>{{ item }}</span>
                              <a @click.prevent="removeEmail(item)" href="#">X</a>
                            </li>
                            <li>
                              <input type="text" v-model="customemail" @keyup.enter="addemail(customemail)"
                                class="form-control" placeholder="Type in email address & press enter">
                            </li>
                          </ul>
                          <div v-if="errorsemail" style="
                  color: rgba(243, 69, 58, 0.8);
                  font-size: 13px;
                  font-weight: 500;
                  display: block !important;
                ">{{ errorsemail }}</div>
                        </div>
                        <div class="modal-footer" v-if="emaillist && emaillist.length > 0" style="padding-top: 0px">
                          <button type="button" class="primary-btn ripple pull-right" data-dismiss="modal"
                            aria-label="Close" @click="senddetailsoveremail()">Send</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {{ getPdfUrl }} {{ getdatafromparent }}
                <ul class="print-export new-rule-border">


                  <li style="border-right: 1px solid #eeeeee;">
                    <a v-on:click="onPrintVitals()">
                      <i class="material-icons print">print</i>
                    </a>
                  </li>
                  <!-- <li style="border-right: 1px solid #eeeeee" v-if="$route.name=='staffdashboard'">
                    <a data-target="#Sendemailin" data-toggle="modal" v-on:click="showEmailPopup()">
                      <i class="material-icons">email</i>
                    </a>
                  </li> -->

                  <li class="mt-1">
                    <span style="margin-right:10px;">
                      <span v-if="printable_headerinves">{{ $t('Hide') }}</span>
                      <span v-if="!printable_headerinves">{{ $t('Show') }}</span>{{ $t('Header') }}
                    </span>
                    <label class="container customcheck pr-1" style="width:auto;">
                      <input type="checkbox" id="printableheaderinves" v-model="printable_headerinves"
                        v-on:click="storeprintableheader()">
                      <span class="checkmark"></span>
                    </label>
                  </li>
                </ul>
                <div class="close-sec-hold" style="right:-15px;">
                  <button type="button" class="close pl-2" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
              </div>
              <div id="modalListViewvitalssPrint" :style="{ fontFamily: this.$t('fontfam') }"
                style="width:100%; margin-top: 10px;" v-if="vitalsobj || vitalsobj != null || vitalsobj != undefined">
                {{ getsignaturepath }} {{ getDownloadUrl }}
                <div v-if="tenantId == '44acd54f-5f3b-4567-a1a0-ca8e25d8ddc9'"
                  :class="printable_headerinves ? 'page-header' : 'no-header'">
                  <table width="100%" cellspacing="0" cellpadding="0" border="0"
                    style="border-bottom:1px solid #d4d5d7;margin-top:15px" v-if="printable_headerinves">
                    <tr>
                      <td>
                        <div class="clinic-logo-hold">
                          <img v-if="ClicnicUrllogo != '' && printable_headerinves" :src="ClicnicUrllogo" height="160px"
                            width="Auto">
                        </div>
                      </td>
                    </tr>
                    <tr style="padding: 0px 40px; background-color: rgb(255, 255, 255);">
                      <td style="padding:15px 30px 10px 0;" class="wrapper1" width="50%" valign="top" align="left">
                        <table width="100%" cellspacing="0" cellpadding="0" border="0" v-if="vitalsobj.businesssetup">


                        </table>
                      </td>

                      <td class="wrapper1" width="50%" valign="top" text-align="center" style="padding-bottom:10px;">
                        <table width="100%" cellspacing="0" cellpadding="0" border="0">
                          <tr>
                            <td valign="top" align="right" style="display:block;">
                              <span align="right"
                                style="color:#212529;  font-size:14px;font-weight:500; line-height:140%;">
                                <span
                                  v-if="Doctordetailsshow == true && vitalsobj.staffDetails.title && vitalsobj.staffDetails.first_name">{{ vitalsobj.staffDetails.title }}
                                  {{ vitalsobj.staffDetails.first_name }} {{ vitalsobj.staffDetails.last_name == null ? ""
                                    :vitalsobj.staffDetails.last_name}}</span>
                              </span>
                              <span v-if="Doctordetailsshow == true"
                                style="color: #212529;   font-size: 14px; font-weight: 500; line-height: 140%;width:100%;display: block; ">{{ qualification }}</span>
                              <span align="right"
                                style="color:#212529;  font-size:14px;font-weight:500; line-height:140%;">
                                <span
                                  v-if="vitalsobj && vitalsobj.staffDetails && vitalsobj.staffDetails.category_list">{{ processItems }}</span>
                              </span>

                              <span align="right"
                                style="color:#212529;  font-size:14px;font-weight:500; line-height:140%;">
                                <span
                                  v-if="Doctordetailsshow == true && vitalsobj.staffDetails && vitalsobj.staffDetails.registration_number">{{ vitalsobj.staffDetails.registration_number }}</span>
                              </span>
                              <br>
                              <span align="right"
                                style="color:#212529;  font-size:14px;font-weight:500; line-height:140%;"
                                v-if="Doctordetailsshow == true && location_tephonedetails">
                                <span>{{ location_tephonedetails }}<br /></span>
                              </span>

                              <span align="right"
                                style="color:#212529;  font-size:14px;font-weight:500; line-height:140%;">
                                <span>
                                  Tmn 2012 0001692 ktk
                                </span>
                              </span>
                            </td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                  </table>
                </div>
                <HeaderWrapper :printable="printable_headerinves" :class="printable_headerinves ? 'page-header' : 'no-header'">
                  <table width="100%" cellspacing="0" cellpadding="0" border="0"
                    style="border-bottom:1px solid #d4d5d7;margin-top:15px" v-if="printable_headerinves">
                    <tr>
                      <td>
                        <div class="clinic-logo-hold">
                          <img v-if="ClicnicUrllogo != '' && printable_headerinves" :src="ClicnicUrllogo" height="60px"
                            width="Auto">
                        </div>
                      </td>
                    </tr>
                    <tr style="padding: 0px 40px; background-color: rgb(255, 255, 255);">
                      <td style="padding:15px 30px 10px 0;" class="wrapper1" width="50%" valign="top" align="left">
                        <table width="100%" cellspacing="0" cellpadding="0" border="0" v-if="vitalsobj.businesssetup">

                          <tr v-if="vitalsobj.businesssetup">
                            <td valign="top" align="left" style="display:block;"
                              v-if="vitalsobj.businesssetup.location">
                              <span v-if="vitalsobj.businesssetup.name"
                                v-html="vitalsobj.businesssetup.name"></span></br v-if="vitalsobj.businesssetup.name">
                              <span style="color:#333333;  font-size:14px;font-weight:normal; line-height:140%;"
                                v-if="vitalsobj.businesssetup.location && vitalsobj.businesssetup.location.address"
                                v-html="vitalsobj.businesssetup.location.address"></span>
                            </td>
                          </tr>
                        </table>
                      </td>

                      <td class="wrapper1" width="50%" valign="top" text-align="center" style="padding-bottom:10px;">
                        <table width="100%" cellspacing="0" cellpadding="0" border="0">
                          <tr>
                            <td valign="top" align="right" style="display:block;">
                              <span align="right"
                                style="color:#212529;  font-size:14px;font-weight:500; line-height:140%;">
                                <span
                                  v-if="Doctordetailsshow == true && vitalsobj.staffDetails.title && vitalsobj.staffDetails.first_name">{{ vitalsobj.staffDetails.title }}
                                  {{ vitalsobj.staffDetails.first_name }} {{ vitalsobj.staffDetails.last_name == null ? ""
                                    :vitalsobj.staffDetails.last_name}}</span>
                              </span>
                              <span
                                style="color: #212529;   font-size: 14px; font-weight: 500; line-height: 140%;width:100%;display: block; ">{{ qualification }}</span>
                              <span align="right"
                                style="color:#212529;  font-size:14px;font-weight:500; line-height:140%;">
                                <span
                                  v-if="vitalsobj && vitalsobj.staffDetails && vitalsobj.staffDetails.category">{{ vitalsobj.staffDetails.category }}</span>
                              </span>

                              <span align="right"
                                style="color:#212529;  font-size:14px;font-weight:500; line-height:140%;">
                                <span
                                  v-if="Doctordetailsshow == true && vitalsobj.staffDetails && vitalsobj.staffDetails.registration_number">{{ vitalsobj.staffDetails.registration_number }}</span>
                              </span>
                              <span align="right"
                                style="color:#212529;  font-size:14px;font-weight:500; line-height:140%;"
                                v-if="Doctordetailsshow == true && location_tephonedetails">
                                <span>{{ location_tephonedetails }} <br /></span>
                              </span>
                              <span align="right"
                                style="color:#212529;  font-size:14px;font-weight:500; line-height:140%;"
                                v-if="vitalsobj.businessappintmenturl && vitalsobj.businessappintmenturl != 'null' && !IsVS">

                                <a style="color: rgb(33, 37, 41); text-decoration: none;" target="_blank"
                                  :href="'https://' + vitalsobj.businessappintmenturl" title="Mini-site URL"
                                  ref="Mini-site URL">{{ vitalsobj.businessappintmenturl.split('/')[0] }}</a>
                              </span>
                            </td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                  </table>
                </HeaderWrapper>

                <table width="100%">
                  <thead>
                    <tr>
                      <td>

                        <div :class="printable_headerinves ? 'page-header-space' : 'page-header-nospace'"></div>
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <div class="page">
                          <table width="100%" cellspacing="0" cellpadding="0" border="0"
                            style="border-bottom:solid 1px #ccc !important;">
                            <tr>
                              <td style=" border-bottom:1px solid #d4d5d7;" class="wrapper1" width="70%" valign="top"
                                align="left">

                                <table width="100%" cellspacing="0" cellpadding="0" border="0">
                                  <tr v-if="vitalsobj">
                                    <td valign="top" align="left" style="padding:10px 0;"
                                      v-if="vitalsobj.patientdetails">
                                      <span style="display:block; float:left; width:100%;">
                                        <span
                                          style="font-weight:500;  font-size:14px; line-height:170%; width:136px; display:inline-block; float:left;">{{ $t('Patientname') }}</span>
                                        <span style="font-weight:400; color:#333333; width:auto; "
                                          v-if="vitalsobj.patientdetails && vitalsobj.patientdetails.name">:
                                          {{ vitalsobj.patientdetails.name }}</span>
                                      </span>
                                      <span style="display:block; float:left; width:100%;">
                                        <span
                                          style="font-weight:500;  font-size:14px; line-height:170%; width:136px; display:inline-block; float:left;">{{ $t('RegistrationNo') }}</span>
                                        <span style="font-weight:400; color:#333333; width:auto; ">:
                                          {{ vitalsobj.patientdetails.patient_RegId }}</span>
                                      </span>

                                      <span style="display:block; float:left; width:100%;">
                                        <span
                                          style="font-weight:500;  font-size:14px; line-height:170%; width:136px; display:inline-block; float:left;">{{
                                          $t('AgeSex') }}</span>
                                        <span style="font-weight:400; color:#333333; width:auto; ">
                                          :
                                          <span
                                            v-if="ageCalculated !== 'N/A' && vitalsobj.patientdetails.gender">{{ ageCalculated }}
                                            /</span>
                                          <span
                                            v-else-if="vitalsobj.patientdetails.age && vitalsobj.patientdetails.gender">
                                            {{ vitalsobj.patientdetails.age }} / </span>
                                          <span v-else>N/A /</span>
                                          <span class="c_name" style="text-transform:capitalize"
                                            v-if="vitalsobj.patientdetails.gender">{{ vitalsobj.patientdetails.gender }}</span>
                                        </span>
                                      </span>

                                    </td>
                                  </tr>
                                </table>
                              </td>
                              <td class="wrapper1" width="30%" valign="top" text-align="right"
                                style="padding:10px 0px 10px 0; border-bottom:1px solid #d4d5d7;" v-if="!IsVS">
                                <img v-if="getQRCode()" :src="getQRCode()" width="81" height="80" style="float:right;">
                                <img v-else class="disable-holdsec"
                                  src="https://s3.amazonaws.com/genamet-static-uploads-dev/9c42767e-1559-426b-8c70-b54299e091dd/images/qr-code.gif"
                                  width="81" height="80" style="float:right;">
                              </td>
                            </tr>
                          </table>

                          <!-- vitals pop up here -->
                          <h3 class="mt-2">Vitals</h3>
                          <table class="vitals-table">
                            <thead>
                              <tr class="vitals-header">
                                <th>Date</th>
                                <th>Height</th>
                                <th>Weight</th>
                                <th>BMI</th>
                                <th>Blood Pressure</th>
                                <th>Heart Rate</th>
                                <th>Respiratory Rate</th>
                                <th>O2 Sat</th>
                                <th>Temperature</th>
                              </tr>
                            </thead>

                            <tbody>
                              <tr class="vitals-row" v-for="(row, i) in vitalsTableRows" :key="i">
                                <td>{{ row.date }}</td>
                                <td>{{ row.height }}</td>
                                <td>{{ row.weight }}</td>
                                <td>{{ row.bmi }}</td>
                                <td>{{ row.bp }}</td>
                                <td>{{ row.heart }}</td>
                                <td>{{ row.resp }}</td>
                                <td>{{ row.o2 }}</td>
                                <td>{{ row.temp }}</td>
                              </tr>
                            </tbody>
                          </table>



                          <table width="100%" style="border-bottom:1px solid #d4d5d7;" border="0" cellspacing="0"
                            cellpadding="0" align="center">
                            <tr v-if="Doctordetailsshow == true">
                              <td align="right" valign="top" bgcolor="#FFFFFF"
                                style="padding:30px 0 15px 0; margin: 0;">
                                <img v-if="fileUrl != ''" :src="fileUrl" height="50px" width="Auto">
                                <span style="width:100%; text-align:right; display:block; padding:10px 0;"
                                  v-if="Doctordetailsshow == true && vitalsobj && vitalsobj.staffDetails">{{ vitalsobj.staffDetails.title }}
                                  {{ vitalsobj.staffDetails.first_name }} {{ vitalsobj.staffDetails.last_name }}</span>
                              </td>
                            </tr>
                            <tr v-if="vitalsobj.footernote1">
                              <td align="center" valign="top">
                                <p v-html="vitalsobj.footernote1" style="margin:10px 0 10px;font-size:12px;"></p>
                              </td>
                            </tr>
                          </table>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr>
                      <td>
                        <div :class="printable_headerinves ? 'page-footer-space' : 'page-footer-nospace'"></div>
                      </td>
                    </tr>
                  </tfoot>
                </table>
                <div :class="printable_headerinves ? 'page-footer' : 'no-footer'">
                  <table width="100%" v-if="printable_headerinves">
                    <tr>
                      <td align="center" style="padding: 10px 0;">
                        <span class="body-text"
                          style="    color: #212529;  font-size: 13px; font-weight:500; font-style: normal; ">{{
                            $t('Thisdocumentisdigitallysignedandhencenomanualsignatureisrequired') }}</span>
                      </td>
                    </tr>
                    <tr>
                      <td align="center">
                        <span style="font-size: 13px;color: #aaa;">{{ $t('Poweredby') }}</span>
                        <a href="https://www.genamet.com/" target="_blank" style="text-decoration:none;">
                          <span
                            style="font-size: 13px;color: rgb(0, 86, 224); text-decoration:none;">www.genamet.com</span>
                        </a>
                        <br>
                        <a href="#" style="margin-right:10px;">
                          <img style="padding-top: 10px;"
                            src="https://s3.amazonaws.com/genamet-static-uploads-dev/9c42767e-1559-426b-8c70-b54299e091dd/images/powered-genamet.png">
                        </a>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import InvoiceReceiptApi from "../../api/InvoiceReceipt.js";
import rest_service from "@/api/rest_service";
import { mapActions, mapGetters, Store } from "vuex";
import Axios from "axios";
import commonhelper from "@/common/commonhelper";
import HeaderWrapper from "@/components/Headers/HeaderWrapper";

export default {
  name: "vitalsPrint-popup",
  mixins: [commonhelper],
  props: ["vitalsobj", ""],
  components: {
    HeaderWrapper
  },
  data() {
    return {
       headerdisplaysetting:"provider",
      patientemail: "",
      showhideemailpopup: false,
      emaillist: [],
      patientmobile: "",
      customemail: "",
      errorsemail: null,
      qualification: "",
      showModal: false,
      getdownloadfileUrl: "",
      signatureFlag: "staffSign",
      fileUrl: "",
      isrefreshinv: true,
      printable_headerinves: false,
      location_tephonedetails: null,
      ClicnicUrllogo: null,
      ageCalculated: "N/A",
      tenantId: '',
      Doctordetailsshow: true,
      IsVS: false,
      locationdata: null,
    };
  },
  created() {
    //rest_service.getQRCodeData();
    this.tenantId = localStorage.tenantid;
    this.emaillist = [];
    let business_data = window.localStorage.getItem('tenantbusinesssetup');
    if (business_data) {
      var Jsonbusinessdata = JSON.parse(business_data);
      if(Jsonbusinessdata.isVS && !Jsonbusinessdata.vs_with_standard_features){this.IsVS = Jsonbusinessdata.isVS;}
      if (Jsonbusinessdata.printheadersetting) { this.headerdisplaysetting = Jsonbusinessdata.printheadersetting }
    }
  },
  computed: {
    ...mapGetters([
      //"gett_businesssetup",
      "gett_pdfurl"
    ]),
    processItems() {
      return this.vitalsobj.staffDetails.category_list.map(item => item.category).join(', ');
    },
    getsignaturepath() {
      var signaturefilename = "";
      if (this.vitalsobj.staffDetails) {
        //rest_service.getQRCodeData();
        if (
          this.vitalsobj.staffDetails.signature_pic_file_name != null
        ) {
          signaturefilename = this.vitalsobj.staffDetails
            .signature_pic_file_name;
          this.foldername =
            this.vitalsobj.staffDetails.tenant_id +
            this.$store.state.helper.tenant_s3upload_Folders
              .signatureDownloadPath +
            signaturefilename;
          this.signatureFlag = "staffSign";
          if (localStorage.getItem("SignatureExpiryDate")) {
            var Expirydate = localStorage.getItem("SignatureExpiryDate");
            var today = new Date();
            Expirydate = new Date(Expirydate);
            Expirydate = Expirydate.toLocaleDateString();
            today = today.toLocaleDateString();
            if (Expirydate > today.toString()) {
              if (localStorage.getItem("SignatureUrl")) {
                this.fileUrl = this.getdownloadfileUrl = localStorage.getItem(
                  "SignatureUrl"
                );
                this.isrefreshinv = false;
              } else {
                this.getUrlFromS3Bucket(this.foldername);
              }
            } else {
              this.getUrlFromS3Bucket(this.foldername);
            }
          } else {
            this.getUrlFromS3Bucket(this.foldername);
          }
        } else {
          this.isrefreshinv = false;
          //this.fileUrl="";
          this.signatureFlag = "";
        }
      }
    },
    getDownloadUrl() {
      //this.fileUrl="";
      if (
        this.getdownloadfileUrl &&
        this.getdownloadfileUrl.length > 0 &&
        this.getdownloadfileUrl.indexOf(
          "documents-gen-ehr-dev.s3.amazonaws.com"
        )
      ) {
        if (
          this.signatureFlag == "staffSign" &&
          this.signatureFlag.length > 0
        ) {
          this.fileUrl = this.getdownloadfileUrl;
        }
      }
    },
    getPdfUrl() {
      if (this.gett_pdfurl && this.vitalsobj.PdfDownload) {
        var win = window.open(this.gett_pdfurl, "_blank");
        if (win) {
          //Browser has allowed it to be opened
          win.focus();
          this.ispdfview = false;
        } else {
          //Browser has blocked it
          alert("Please allow popups for this website");
        }
        this.vitalsobj.PdfDownload = false;
      }
    },
    getdatafromparent() {
      if (this.vitalsobj && this.vitalsobj.provider_id) {
        this.getstaffname(this.vitalsobj.provider_id);
      }
      if (
        this.vitalsobj &&
        this.vitalsobj.provider_id &&
        this.vitalsobj.Dashboardstaff == "Dashboardstaff" &&
        this.vitalsobj.staffDetails != this.vitalsobj.provider_id
      ) {
        this.getstaffbyid(this.vitalsobj.provider_id);
      }
      if (this.vitalsobj && this.vitalsobj.Doctordetailsshow == false) {
        this.Doctordetailsshow = this.vitalsobj.Doctordetailsshow;
      }
      this.setCategory();
      this.printable_headerinves = this.$store.state.helper.printable_header;
      if (localStorage.getItem("AppLocList")) {
        var locationlist = JSON.parse(localStorage.getItem("AppLocList"));
        if (localStorage.slctdappfacltaddr) {
          var selectedAppFacility = JSON.parse(localStorage.slctdappfacltaddr);
          locationlist.forEach(x => {
            if (x.unique_id === selectedAppFacility.unique_id) {
              this.location_tephonedetails = this.sanitizeText(x.clinic_contact_numbers);
              //this.location_address= x.address;
            }
          });
        }
      }
      if (!this.location_tephonedetails) {
        this.location_tephonedetails =
          this.vitalsobj.staffDetails &&
            this.vitalsobj.staffDetails.mobile
            ? this.vitalsobj.staffDetails.mobile
            : "";
      }

      if (localStorage && localStorage.ClicnicUrllogo) {
        this.ClicnicUrllogo = localStorage.ClicnicUrllogo;
      } else {
        if (
          this.$store.state.helper.st_s3bucket_name &&
          this.$store.state.helper.tenant_id &&
          this.$store.state.helper.st_business_logo_folder &&
          this.$store.state.helper.clinicLogoFileName
        ) {
          if (!this.$store.state.helper.clinicLogoUrl) {
            var logoURl =
              process.env.VUE_APP_S3_BUCKET_PUBLIC_NAME +
              this.$store.state.helper.tenant_id +
              process.env.VUE_APP_BUSINESS_LOGO_FOLDER +
              this.$store.state.helper.clinicLogoFileName;
            this.ClicnicUrllogo = this.$store.state.helper.clinicLogoUrl = logoURl;
            if (!localStorage.ClicnicUrllogo) {
              localStorage.setItem("ClicnicUrllogo", logoURl);
            }
          } else {
            this.ClicnicUrllogo = this.$store.state.helper.clinicLogoUrl;
            if (!localStorage.ClicnicUrllogo) {
              localStorage.setItem("ClicnicUrllogo", this.ClicnicUrllogo);
            }
          }
        }
      }
    },
    vitalsTableRows() {
      if (!this.vitalsobj || !Array.isArray(this.vitalsobj.vitals)) {
        return [];
      }

      // vitals is already an array of rows (top 10)
      return this.vitalsobj.vitals.map(function (v) {
        return {
          date: v.date || "",
          height: v.height || "",
          weight: v.weight || "",
          bmi: v.bmi || "",
          bp: v.bp || "",
          heart: v.heartRate || "",
          resp: v.respiratoryRate || "",
          o2: v.o2sat || "",
          temp: v.temperature || ""
        };
      });
    }

  },
  methods: {
    sanitizeText(value) {
      if (!value) return "";
      return value
        .replace(/<script.*?>.*?<\/script>/gi, "")
        .replace(/<\/?[^>]+(>|$)/g, "");
    },

    ...mapActions(["ac_export_to_pdf", "ac_getbusinesssetup"]),
    getappointment(appointmentid) {
      var self = this;
      debugger;
      InvoiceReceiptApi.getappointment(appointmentid).then(
        appointmentdetails => {
          debugger;
          if (appointmentdetails.data) {
            self.patientemail =
              appointmentdetails.data.result.patient_details.email;
            if (self.patientemail) {
              self.emaillist.push(self.patientemail.toLowerCase());
            }
          }
          if (appointmentdetails.data.result.facility) {
            self.locationdata = appointmentdetails.data.result.facility;
          }
        }
      );
    },
    getVitalValue(form, name) {
      const field = form.find(f => f && f.name === name);
      if (!field || !field.value) return "";
      return field.value[0] || "";
    },

    getSelectedUnit(form, name) {
      const field = form.find(f => f && f.name === name);
      if (!field || !field.values) return "";
      const selected = field.values.find(v => v.selected);
      return selected ? selected.value : "";
    },
    showEmailPopup() {
      this.emaillist = [];
      this.getappointment(this.$parent.appointmentdetails.unique_id);
      if (this.emaillist != null) {
        if (this.emaillist.length > 1) {
          while (this.emaillist.length > 1) {
            //     // Remove elements from array
            this.emaillist.pop();
          }
        }
      }
      this.showhideemailpopup = true;
    },
    emailSelectedItems() {
      this.prescriptionobject = this.prescriptionobj;
    },
    showmasterprintpopup: function (jobtype) {
      console.log(
        "this.$refs.masterprintcompref>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>",
        this.$refs.masterprintcompref
      );
      if (jobtype === "email") {
        this.emailSelectedItems();
      }
    },
    senddetailsoveremail() {
      this.onEmailData();
      this.showhideemailpopup = false;
    },
    dismissPrint: function () {
      if (
        this.$refs.masterprintcompref &&
        this.$refs.masterprintcompref._data &&
        this.$refs.masterprintcompref._data.showmasterprint
      ) {
        this.$refs.masterprintcompref._data.showmasterprint = false;
      }
    },

    addemail(val) {
      if (this.validateEmail(val.toLowerCase())) {
        if (this.emaillist.indexOf(val.toLowerCase()) > -1) {
          this.errorsemail = "This email id is already added";
        } else {
          this.emaillist.push(val.toLowerCase().trim());
          this.customemail = "";
        }
      }
    },
    validateEmail(val) {
      let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (val && val.length > 0) {
        if (!re.test(val.toLowerCase())) {
          this.errorsemail = "Please provide a valid email address";
          return false;
        } else {
          this.errorsemail = null;
          return true;
        }
      }
    },
    removeEmail(val) {
      this.emaillist = this.emaillist.filter(e => e !== val.toLowerCase());
    },
    resetEmailparams() {
      this.showhideemailpopup = false;
      this.emaillist = [];
      this.customemail = "";
    },
    onEmailData() {
      if (document.getElementById("modalListViewvitalssPrint")) {
        debugger;
        var self = this;
        let doctorname = "";

        var style = "";
        if (self.tenantId == '44acd54f-5f3b-4567-a1a0-ca8e25d8ddc9') {
          style = ".page-header .clinic-logo-hold { top: 5px;left: 20px;position:absolute;}";
        }

        var content1 =
          "<!DOCTYPE html><html><head><meta http-equiv='Content-Type' content='text/html; charset=utf-8'/><title></title><style>" + self.$t('fonts') + style + ".page-header,.page-header-space{margin-top:30px}.page-footer{width:100%;border-top:1px solid rgb(212, 213, 215)}.page-header{top:0mm;height: 140px;width:100%;border-bottom:1px solid #000;}@page{size:A4;margin:0.50in;}@media print{thead{display:table-header-group}tfoot{display:table-footer-group}button{display:none}body{margin:0}}</style></head><body>" +
          document.getElementById("modalListViewvitalssPrint")
            .outerHTML +
          "</body></html>";

        var data = { data: content1, prefix: "empty" };
        var config = {
          method: "post",
          url: process.env.VUE_APP_HTML_TO_PDF_CLINICAL_NOTES_API,
          headers: {
            "Content-Type": "application/json",
            x_tenant_id: localStorage.tenantid
          },
          data: data
        };
        self.$parent.loadstatusmessage("An email is on the way", false);
        Axios(config)
          .then(function (response) {
            console.clear();
            console.log(JSON.stringify(response.data));
            self.sendNotification(response.data);
            self.$parent.showhideemailpopup = false;
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    },
    sendNotification(urldata) {
      debugger;
      var mobile1 =
        this.vitalsobj.patientdetails.country_code +
        this.vitalsobj.patientdetails.mobile;
      var appid = this.$parent.appointmentdetails.unique_id;
      let data = {
        url: urldata.url,
        emailids: this.emaillist,
        mobile: mobile1,
        appid: appid
      };
      var self = this;
      var role_unique_id =
        JSON.parse(localStorage.loggedInUserInfo).role &&
          JSON.parse(localStorage.loggedInUserInfo).role.unique_id
          ? JSON.parse(localStorage.loggedInUserInfo).role.unique_id
          : "";
      var suburl = "/notification";
      let axiosconfig = {
        method: "post",
        url: rest_service.baseURL + suburl + "/secnn",
        headers: {
          x_tenant_id: localStorage.tenantid,
          role_unique_id: role_unique_id,
          loggedin_user_unique_id: JSON.parse(localStorage.loggedInUserInfo)
            .unique_id,
          route_entity_name: suburl,
          Authorization: localStorage.accesstoken
        },
        data: data
      };
      Axios(axiosconfig)
        .then(response => {
          debugger;
          if (response && response.data && response.data.result) {
            self.$parent.loadstatusmessage(
              "Email has been sent successfully",
              false
            );
            self.$parent.showhideemailpopup = false;
            self.resetEmailparams();
          }
        })
        .catch(function (error) {
          console.log(error);
          self.$parent.loadstatusmessage("Something went wrong", true);
          self.$parent.showhideemailpopup = false;
        });
    },

    prespription_exporttoPDF() {
      this.vitalsobj.PdfDownload = true;
      var content = document.getElementById(
        "modalListViewvitalssPrint"
      ).innerHTML;
      content = content.split('"').join("'");
      content = content.replace("//", "/\\/");
      content = content.replace(/(\r\n\t|\n|\r\t)/gm, "");
      this.ac_export_to_pdf(content);
    },
    storeprintableheader() {
      this.$store.state.helper.printable_header = document.getElementById(
        "printableheaderinves"
      ).checked;
    },
    onPrintVitals() {
      var content = document.getElementById(
        "modalListViewvitalssPrint"
      ).innerHTML;
      var mywindow = window.open("", "Print", "height=600,width=1100");
      // mywindow.document.write(
      //   "<html><head><title></title><style> .vitals-table{width:100%;border-collapse:collapse;background:#fff;border-radius:8px;border:1px solid #ddd;font-size:14px}.vitals-header{background-color:#e4dbdc!important}.vitals-header th{padding:10px;text-align:left;font-weight:600;color:#3d3d3d;border-bottom:1px solid #ddd}.vitals-row td{padding:10px;text-align:left;font-weight:600;color:#3d3d3d}.page-header,.page-header-space{height:140px}.page-header-nospace{height:10px}.page-footer{bottom: 5px;height: 100px;width:100%;border-top:1px solid rgb(212, 213, 215)}.page-header{position:fixed;top:0mm;height: 140px;width:100%;}@page{size:A4;margin: 0.50in;}@media print{thead{display:table-header-group}tfoot{display:table-footer-group}button{display:none}body{margin:0}}</style></head><body>"
      // );
      if(this.headerdisplaysetting=="hospital"){
        mywindow.document.write(
          "<html><head><title></title><style>.title-details{display:flex;grid-gap:60px;text-align:center;align-items:center}.title-details>div>img{max-width:120px}.title-details p{margin:0 0 5px}.page-header,.page-header-space{}.page-header-space{margin-top:30px;}.page-header-nospace{height:10px}.page-footer,.page-footer-space,.page-footer-nospace{height:100px}.page-footer{position:fixed;bottom: 5px;height: 100px;width:100%;border-top:1px solid rgb(212, 213, 215)}.page-header{width:100%;border-bottom:1px solid #000;}@page{size:A4;margin: 0.50in}@media print{thead{display:table-header-group}tfoot{display:table-footer-group}button{display:none}body{margin:0}}.vitals-table{width:100%;border-collapse:collapse;background:#fff;border-radius:8px;border:1px solid #ddd;font-size:14px}.vitals-header{background-color:#e4dbdc!important}.vitals-header th{padding:10px;text-align:left;font-weight:600;color:#3d3d3d;border-bottom:1px solid #ddd}.vitals-row td{padding:10px;text-align:left;font-weight:600;color:#3d3d3d}</style></head><body>"
        );
      }
      else{
        mywindow.document.write(
         "<html><head><title></title><style> .vitals-table{width:100%;border-collapse:collapse;background:#fff;border-radius:8px;border:1px solid #ddd;font-size:14px}.vitals-header{background-color:#e4dbdc!important}.vitals-header th{padding:10px;text-align:left;font-weight:600;color:#3d3d3d;border-bottom:1px solid #ddd}.vitals-row td{padding:10px;text-align:left;font-weight:600;color:#3d3d3d}.page-header,.page-header-space{height:140px}.page-header-nospace{height:10px}.page-footer{bottom: 5px;height: 100px;width:100%;border-top:1px solid rgb(212, 213, 215)}.page-header{position:fixed;top:0mm;height: 140px;width:100%;}@page{size:A4;margin: 0.50in;}@media print{thead{display:table-header-group}tfoot{display:table-footer-group}button{display:none}body{margin:0}}.page{padding-top:15px;}</style></head><body>"
       );
      }
      mywindow.document.write(content);
      mywindow.document.write("</body></html>");
      mywindow.focus();
      mywindow.print();
      mywindow.close();
    },
    getUrlFromS3Bucket(bucketnameandkey) {
      var self = this;
      var suburl = "/S3Proxy";
      rest_service
        .downloadFromS3Bucket(suburl, this.tenantId, bucketnameandkey)
        .then(function (response) {
          if (response != null && response.data != null) {
            self.getdownloadfileUrl = response.data.result;
            var url_string = response.data.result;
            var url = new URL(url_string);
            var timestamp = url.searchParams.get("Expires");
            timestamp = Math.floor(timestamp * 1000);
            var ExpiryDateTime = new Date(timestamp);
            localStorage.setItem("SignatureExpiryDate", ExpiryDateTime);
            localStorage.setItem("SignatureUrl", self.getdownloadfileUrl);
          } else {
            return null;
          }
        })
        .catch(function (error) {
          return error;
        })
        .finally(() => {
          this.isrefreshinv = false;
        });
    },
    getstaffname(staff_id) {
      this.getpatientdetails(this.vitalsobj.patientdetails.unique_id);
      let self = this;
      var staff_fullname = "";
      var masterdata = {
        id: staff_id,
        projectionitems: "first_name,educationalQualificationsObjectArray"
      };
      rest_service
        .get("/staff/getselectedprojection", localStorage.tenantid, masterdata)
        .then(respo => {
          if (respo.data && respo.data.result) {
            self.staff_data = respo.data.result;
            this.qualification = "";
            if (
              self.staff_data.educationalQualificationsObjectArray != null ||
              self.staff_data.educationalQualificationsObjectArray != undefined
            ) {
              for (
                var i = 0;
                i < self.staff_data.educationalQualificationsObjectArray.length;
                i++
              ) {
                self.qualification +=
                  self.staff_data.educationalQualificationsObjectArray[
                    i
                  ].educationalQualifications;
                if (
                  i <
                  self.staff_data.educationalQualificationsObjectArray.length -
                  1
                ) {
                  self.qualification += ",";
                } else {
                  self.qualification = self.qualification;
                }
              }
            }
            if (self.staff_data.first_name && self.staff_data.last_name) {
              self.vitals_updated_doctor =
                self.staff_data.first_name + self.staff_data.last_name;
            } else {
              self.vitals_updated_doctor = self.staff_data.first_name;
            }
          } else {
            staff_fullname = "";
          }
          // return staff_fullname;
        });

      return staff_fullname;
    },
    getstaffbyid(id) {
      var self = this;
      var suburl = "/staff";
      rest_service
        .getbyid(suburl, id, this.vitalsobj.tenant_id, "get?id=" + id)
        .then(function (response) {
          if (response != null && response.data != null) {
            self.vitalsobj.staffDetails = response.data.result;
            self.setCategory();
          } else {
            return null;
          }
        })
        .catch(function (error) {
          return error;
        });
    },
    getpatientdetails: function (patientid) {
      debugger
      var self = this;
      rest_service
        .getPatientInfo("/patient", this.vitalsobj.tenant_id, patientid)
        .then(respo => {
          if (respo.data && respo.data.result) {
            respo.data.result = JSON.parse(respo.data.result);
            if (respo.data.result.Date_of_birth) {
              self.ageCalculated = commonhelper.getAge(
                respo.data.result.Date_of_birth
              );
            }
            else if (respo.data.result.age) {
              self.ageCalculated = respo.data.result.age + " yrs";
            }
            else {
              self.ageCalculated = "N/A";
            }


          }
        })
        .catch(function (error) {
          return error;
        });
    },
    getSignature: function () {
      this.foldername =
        this.tenantId +
        this.$store.state.helper.patient_s3upload_Folders
          .scanReportDownloadPath +
        item;
    },
    show() {
      this.showModal = true;
    },
    hide() {
      this.showModal = false;
    },
    getQRCode() {
      rest_service.getQRCodeData();
      return this.$store.state.helper.qrcodeimagestr;
    },
    setCategory() {
      var self = this;
      let default_category = "";
      if (
        self.vitalsobj.staffDetails &&
        self.vitalsobj.staffDetails.specialization
      ) {

        self.vitalsobj.staffDetails.category =
          self.vitalsobj.staffDetails.specialization;
      }
    },
  }
};
</script>
<style scoped>
#modalListViewvitalssPrint table tbody td {
  border-right: 0 !important;
}

#modalListViewvitalssPrint table thead tr {
  background: #fff;
  border: 0 !important;
}

#modalListViewvitalssPrint table tbody {
  border: 0 !important;
}

.page-header {
  position: static;
  width: 100%;
  height: auto;
}

.page-header .clinic-logo-hold {
  top: 5px;
  left: 20px;
}

.page-header-space {
  height: auto;
}

.close-sec-hold .close {
  padding: 0;
  margin: 0;
  position: absolute;
  top: -48px;
  right: -15px;
}

.vitals-table {
  width: 100%;
  border-collapse: collapse;
  background: #ffffff;
  border-radius: 8px;
  border: 1px solid #ddd;
  font-size: 14px;
}


.vitals-header {
  background-color: #e4dbdc !important;
}

.vitals-header th {
  padding: 10px;
  text-align: left;
  font-weight: 600;
  color: #3d3d3d;
  border-bottom: 1px solid #ddd;
}

.vitals-row td {
  padding: 10px;
  text-align: left;
  font-weight: 600;
  color: #3d3d3d;
}

#investi-print-pdf .modal-dialog.wider-1.wider-print9 {
  max-width: 1100px !important;
}
</style>